import { borderWidths, radii } from '../tokens/border';
import {
  textColors,
  neutralColors,
  iconColors,
  backgroundColors,
  secondaryColors,
} from '../tokens/color';

export const enecoButtonColors = {
  // Primary onLight Text
  buttonPrimaryOnLightDefaultText: textColors.textInverted,

  // Primary onLight Background
  buttonPrimaryOnLightDefaultBackground: '#007250',
  buttonPrimaryOnLightHoverBackground: `#00593F`,
  buttonPrimaryOnLightFocusBackground: `#00593F`,
  buttonPrimaryOnLightPressedBackground: `#007250`,

  // Primary onDark Text
  buttonPrimaryOnColorDefaultText: textColors.textPrimary,
  buttonPrimaryOnColorHoverText: textColors.textBrand,
  buttonPrimaryOnColorFocusText: textColors.textBrand,
  buttonPrimaryOnColorPressedText: textColors.textBrand,

  // Primary onDark Background
  buttonPrimaryOnColorDefaultBackground: neutralColors.neutralWhite,
  buttonPrimaryOnColorHoverBackground: neutralColors.neutralWhite,
  buttonPrimaryOnColorFocusBackground: neutralColors.neutralWhite,
  buttonPrimaryOnColorPressedBackground: neutralColors.neutralWhite,

  // Primary onDark Icon
  buttonPrimaryOnColorDefaultIcon: iconColors.iconPrimary,
  buttonPrimaryOnColorHoverIcon: iconColors.iconBrand,
  buttonPrimaryOnColorFocusIcon: iconColors.iconBrand,
  buttonPrimaryOnColorPressedIcon: iconColors.iconBrand,

  // Secondary
  buttonSecondaryDefaultText: textColors.textBrand,
  buttonSecondaryDefaultBackground: backgroundColors.backgroundPrimary,
  buttonSecondaryDefaultBorderColor: secondaryColors.accentGreen700,
  buttonSecondaryHoverText: secondaryColors.accentGreen800,
  buttonSecondaryHoverBackground: secondaryColors.accentGreen100,
  buttonSecondaryHoverBorderColor: secondaryColors.accentGreen800,
  buttonSecondaryFocusText: neutralColors.neutral900,
  buttonSecondaryFocusBackground: backgroundColors.backgroundPrimary,
  buttonSecondaryFocusBorderColor: neutralColors.neutralBlack,
  buttonSecondaryPressedBackground: secondaryColors.accentGreen200,
  buttonSecondaryPressedText: secondaryColors.accentGreen800,
  buttonSecondaryPressedBorderColor: secondaryColors.accentGreen800,

  // Loading
  buttonLoadingDefaultText: neutralColors.neutralWhite,
  buttonLoadingDefaultBackground: secondaryColors.blue700,
};

export const enecoButtonBorderWidths = {
  buttonSecondaryDefaultBorderWidth: borderWidths.m,
};

export const enecoButtonOutlineWidths = {
  buttonSecondaryFocusedOutlineWidth: borderWidths.s,
};

export const enecoButtonBorderRadii = {
  buttonBorderRadiusDefault: radii.s,
};

export const enecoButtonChevronDisplay = {
  buttonChevronDisplay: 'none',
};
